// extracted by mini-css-extract-plugin
module.exports = {"selectedFileName":"uploadFileFIeld_selectedFileName__2h61Q","selectedFilesList":"uploadFileFIeld_selectedFilesList__3eGBu"};